const doc = [({"da":({"js":({"admin":({"economy":({"accounts":({"account_plan":"Kontoplan", "account_types":"Kontotyper"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;